// src/pages/FormPage.js
import React, { memo, useEffect, useMemo } from "react";
import DynamicUserForm from "../components/form/DynamicUserForm";
import { useLocation } from "react-router-dom";
import { trackEvent } from "../utils/analytics/track";

/**
 * FormPage
 * --------
 * Route wrapper that mounts <DynamicUserForm/>.
 *
 * In patientEdit mode:
 *  - do NOT use ProfilePrefetch cache
 *  - only use navigation state prefill
 */
function FormPage() {
  const { state } = useLocation(); // { prefill, mode } | undefined
  const mode = state?.mode ?? "default";

  const initialData = useMemo(() => {
    // Explicitly avoid cache in this context
    return state?.prefill ?? {};
  }, [state?.prefill]);

  useEffect(() => {
    trackEvent("profile_form_view", {
      mode,
      hasPrefillFromNav: !!state?.prefill,
      hasPrefillFromCache: false,
    });
  }, [mode, state?.prefill]);

  return (
    <div className="form-page w-full h-full max-w-lg">
      <DynamicUserForm initialData={initialData} mode={mode} />
    </div>
  );
}

export default memo(FormPage);
